import { Trans } from 'react-i18next'

import { Accordion } from '@/components/Accordion/Accordion'

import BrandingAccordion from './components/SettingPanel/BrandingAccordion'
import DomainAccordionItem from './components/SettingPanel/DomainAccordionItem'
import InfoAccordionItem from './components/SettingPanel/InfoActionAccordion'
import LanguageAccordionItem from './components/SettingPanel/LanguageAccordionItem'
import NavigationBarAccordionItem from './components/SettingPanel/NavigationBarAccordionItem'
import PrivacyAccordionItem from './components/SettingPanel/PrivacyAccordionItem'
import StatusbarAccordionItem from './components/SettingPanel/StatusbarAccordionItem'
import SwitchAccordionItem from './components/SettingPanel/SwitchAccordionItem'
import TopBarAccordionItem from './components/SettingPanel/TopBarActionItem'

/**
 * `SettingPanel` function is a component that displays various settings for the builder in a
 * side panel. Each setting is represented as an accordion item, and the panel includes settings
 * for information, top bar, navigation bar, domain, language and privacy.
 *
 * The accordion allows only one item to be open at a time. The initial active item is 'setting-logo'.
 *
 * @returns {JSX.Element} Returns a JSX element that contains the settings interface in the side panel.
 *
 */
export function SettingPanel() {
  return (
    <div className='setting-panel mk-builder-panel'>
      <div className='p-4'>
        <div className='uppercase pt-2'>
          <Trans>Style</Trans>
        </div>
      </div>
      <Accordion initialActiveItems={['setting-logo']} openMultiple={false}>
        <InfoAccordionItem />
        <SwitchAccordionItem />
        <StatusbarAccordionItem />
        <TopBarAccordionItem />
        <NavigationBarAccordionItem />
        {/*<DataSourceAccordionItem />*/}
        <BrandingAccordion />
        <DomainAccordionItem />
        <LanguageAccordionItem />
        <PrivacyAccordionItem />
      </Accordion>
    </div>
  )
}
